import axiosClient from 'utils/axios-client';
import { UserDto } from 'dto/users/user.dto';

export const usersAPI = {
  getMe(): Promise<UserDto> {
    return axiosClient.get('users/me');
  },
};
